var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wx-miniprogram-wrapper"},[_c('img',{attrs:{"src":require("../../../assets/images/wx_miniprogram.svg")}}),_vm._v(" "),_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('robot_setting.scan_qrcode')))]),_vm._v(" "),_c('p',{staticClass:"robot-name"},[_vm._v(_vm._s(_vm.robotName))]),_vm._v(" "),_c('div',{staticClass:"qr-code",attrs:{"id":"qrcode"}})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e1d658d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/RobotSetting/_components/WechatMiniprogram.vue
// module id = null
// module chunks = 